// contexts/LoginModalContext.jsx
import { createContext, useState, useContext } from 'react';

const LoginModalContext = createContext();

export const useLoginModal = () => {
    const context = useContext(LoginModalContext);
    if (!context) {
        throw new Error('useLoginModal must be used within LoginModalProvider');
    }
    return context;
};

export const LoginModalProvider = ({ children }) => {
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [onLoginSuccessCallback, setOnLoginSuccessCallback] = useState(null);

    const openLoginModal = (callback = null) => {
        if (callback) {
            setOnLoginSuccessCallback(() => callback);
        }
        setIsLoginModalOpen(true);
    };

    const closeLoginModal = () => {
        setIsLoginModalOpen(false);
        setOnLoginSuccessCallback(null);
    };

    const handleLoginSuccess = (userData) => {
        if (onLoginSuccessCallback) {
            onLoginSuccessCallback(userData);
        }
        closeLoginModal();
    };

    return (
        <LoginModalContext.Provider
            value={{
                isLoginModalOpen,
                openLoginModal,
                closeLoginModal,
                handleLoginSuccess
            }}
        >
            {children}
        </LoginModalContext.Provider>
    );
};